import { FaFacebookF, FaWhatsapp, FaTwitter, FaRegEnvelope } from 'react-icons/fa';

import { SocialMedia } from './models';
import { isEnglish } from '../utils/helper/helpers';
import { mainConfig } from './config.provider';

const getShareAlt = (socialMedia: SocialMedia) => `${isEnglish() ? 'Share via' : 'Teilen über'} ${socialMedia}`;

export const createShareInfo = (socialMedia: SocialMedia) => {
    const useCustomText = (value?: string) => value || `${mainConfig.title}%0A${mainConfig.description}:`;

    switch (socialMedia) {
        case SocialMedia.Facebook:
            return `https://www.facebook.com/sharer.php?u=${mainConfig.url}`;
        case SocialMedia.Mail:
            return `mailto:?subject=${mainConfig.headline}&body=${useCustomText(mainConfig.mailShareText)}%0A${
                mainConfig.url
            }`;
        case SocialMedia.Twitter:
            return `https://twitter.com/intent/tweet?url=${mainConfig.url}&text=${encodeURIComponent(
                useCustomText(mainConfig.twitterShareText)
            )}&via=br_data&related=br_data,br24,br_press
`;
        case SocialMedia.Whatsapp:
            return `whatsapp://send?text=${useCustomText(mainConfig.whatsappShareText)}%0A${mainConfig.url}`;
    }
};

export const SocialMediaMap = {
    [SocialMedia.Facebook]: {
        icon: FaFacebookF,
        color: '#3b5998',
        alt: getShareAlt(SocialMedia.Facebook),
        link: createShareInfo(SocialMedia.Facebook)
    },
    [SocialMedia.Whatsapp]: {
        icon: FaWhatsapp,
        color: '#4dc247',
        alt: getShareAlt(SocialMedia.Whatsapp),
        link: createShareInfo(SocialMedia.Whatsapp)
    },
    [SocialMedia.Twitter]: {
        icon: FaTwitter,
        color: '#4099ff',
        alt: getShareAlt(SocialMedia.Twitter),
        link: createShareInfo(SocialMedia.Twitter)
    },
    [SocialMedia.Mail]: {
        icon: FaRegEnvelope,
        color: '#cb2323',
        alt: getShareAlt(SocialMedia.Mail),
        link: createShareInfo(SocialMedia.Mail)
    }
};
